import {FC, useMemo} from 'react'
import {ID} from '../../../../../_metronic/helpers'
import {useKTable} from '../../../contexts/KTableProvider'
type Props = {
  id: ID
  clickHandler?: (id: ID) => void
}

const KTableSelectionCellLav: FC<Props> = ({id, clickHandler}) => {
  const {selectedLav, onSelectLav} = useKTable()
  const isSelected = useMemo(() => selectedLav.includes(id), [id, selectedLav])
  const handleChangeSelect = (id: any) => {
    onSelectLav(id)
    if (clickHandler) {
      clickHandler(id)
    }
  }

  return (
    <>
      <div className='form-check form-check-custom form-check-solid ps-4'>
        <input
          className='form-check-input border border-gray-500'
          type='checkbox'
          data-kt-check={isSelected}
          data-kt-check-target='#kt_table_users .form-check-input'
          checked={isSelected}
          onChange={() => {
            handleChangeSelect(id)
          }}
        />
      </div>
    </>
  )
}

export {KTableSelectionCellLav}
